export default __webpack_public_path__ + "static/media/Dog Park- Dog.906e7b99.jpg";